module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg14_bar.a9b5ae87.jpg";